'use strict';

angular.module('shiftTraderApp')
  .service('ShepherdTourService', ['$log', '$rootScope', '$timeout',
    function ($log, $rootScope, $timeout) {
      var orgProfileTour, mwpTour, mwpFasterTour;

      var stepDefaults = {
        classes: 'shepherd-theme-arrows',
        scrollTo: true
      };

      this.prefixEventName = function(eventName) {
        return 'sa:shepherd:' + eventName;
      };

      var prefixEventName = this.prefixEventName;

      this.triggerEvent = function(eventName, delay) {
        if (_.isUndefined(delay)) {
          console.log('broadcast with no delay: ', eventName);
          $rootScope.$broadcast(prefixEventName(eventName));
        } else {
          console.log('setting up triggerEvent in', delay, ': ', eventName);
          $timeout(function() {
            $rootScope.$broadcast(prefixEventName(eventName));
          }, delay);
        }

      };


      (function initOrgProfileTour() {
        orgProfileTour = new Shepherd.Tour({
          defaults: stepDefaults
        });

        orgProfileTour.addStep('overview', {
          text: 'This is your organization\'s profile. To get here, click on your organization name, shown above. You manage settings related to your store here. Let me show you a couple of things.',
          attachTo: '.top_left_org_name',
          tetherOptions: {
            attachment: 'bottom left',
            targetAttachment: 'top left',
            offset: '-4px -5px'
          }
        });


        orgProfileTour.addStep('managePositions', {
          text: 'Click the Manage Positions button to edit your departments or positions. From here you can also rearrange the order the positions are displayed on the scheduling page.',
          attachTo: '.manage_positions_button',
          tetherOptions: {
            attachment: 'top right',
            targetAttachment: 'top left'
          }
        });

        orgProfileTour.addStep('viewPositionAssignments', {
          text: 'If you click on a position name, you can view and modify which employees have that position.',
          attachTo: '.profile_department_list_area_position right'
        });

        orgProfileTour.addStep('reports', {
          text: 'You can download your Employee Roster at any time, in addition to a weekly report with all of the shifts worked. Useful for variance comparison with your time punch system.',
          attachTo: '.profile_options_right_full_length',
          tetherOptions: {
            attachment: 'bottom center',
            targetAttachment: 'top center'
          }
        });

        orgProfileTour.addStep({
          id: 'infoIconAgain',
          classes: 'shepherd-theme-arrows',
          attachTo: '.sa-icon-info',
          tetherOptions: {
            attachment: 'top right',
            targetAttachment: 'top left'
          },
          text: 'More help is always available by clicking on the <strong>i</strong>. Also check out <a href="https://support.shiftagent.com">https://support.shiftagent.com</a> for any questions you may have.'
        });

        orgProfileTour.addStep('goToMWP', {
          text: 'Next, click on "Scheduling" to learn about Shift Agent\'s scheduling timeline and how it is designed to help you create the best schedule for people and for operations.',
          attachTo: '.manage_work_periods left',
          buttons: []
        });

      }());






      (function initMwpTour() {
        mwpTour = new Shepherd.Tour({
          defaults: stepDefaults
        });

        mwpTour.addStep('departmentBar', {
          text: 'This blue bar shows you the density of shifts in a department across the day. The department name is shown on the left. The positions in this department are listed below.',
          attachTo: '.positions-container-department-name-area right'
        });


        // positionBar Step
        var positionBarStep = new Shepherd.Step(mwpTour, _.extend({
          id: 'positionBar',
          text: 'This bar shows you shifts scheduled for this particular position. As you can see, you can have multiple employees working the same shift at the same time.',
          attachTo: '.positions-name-area',
          tetherOptions: {
            attachment: 'top left',
            targetAttachment: 'bottom center',
            offset: '0px 0px'
          }
        }, stepDefaults));

        positionBarStep.on('show', function() {
          $('.position-shift-list-box').first().addClass('focused');
          $('.positions-name-area').first().addClass('focused');
        });

        positionBarStep.on('hide', function() {
          $('.position-shift-list-box').first().removeClass('focused');
          $('.positions-name-area').first().removeClass('focused');
        });

        mwpTour.addStep(positionBarStep);

        //positionBarCollapse Step
        var positionBarCollapseStep = new Shepherd.Step(mwpTour, _.extend({
          id: 'positionBarCollapse',
          text: 'Position bars can also be collapsed, as seen in this view. When they are collapsed you can easily see how many people are filling that position at any time.',
          attachTo: '.position_bar_container bottom'
        }, stepDefaults));
        positionBarCollapseStep.on('show', function() {
          $rootScope.$broadcast('sa:changePositionCollapseState', true);
        });

        positionBarCollapseStep.on('hide', function() {
          $rootScope.$broadcast('sa:changePositionCollapseState', false);
        });
        mwpTour.addStep(positionBarCollapseStep);

        mwpTour.addStep('shift', {
          tetherOptions: {
            offset: '-5px 0px'
          },
          text: 'This is a shift. It is currently not published. If you put your cursor over the shift and click on EDIT, you can drag the start & end times. You will also notice the employee\'s availability being shown on the top of the shift.',
          attachTo: '.intelli_view_shift bottom'
        });


        var shiftCreatePlusButtonStep = new Shepherd.Step(mwpTour, _.extend({
          id: 'shiftCreatePlusButton',
          attachTo: '.sa-icon-add bottom',
          tetherOptions: {
            targetAttachment: 'bottom left',
            attachment: 'top left',
            offset: '0px 8px'
          },
          text: 'The plus button is one way to create a shift in the corresponding position. Click on it now.',
          buttons: []
        }, stepDefaults));

        var cwpSetShiftTimesStepDereg;
        shiftCreatePlusButtonStep.on('show', function() {
          cwpSetShiftTimesStepDereg = $rootScope.$on(prefixEventName('cwpOpenedSuccessfully'), function() {
            console.log('calling next!');
            mwpTour.next();
            cwpSetShiftTimesStepDereg();
          });
        });

        shiftCreatePlusButtonStep.on('hide', function() {
        });
        mwpTour.addStep(shiftCreatePlusButtonStep);


        var cwpSetShiftTimes = new Shepherd.Step(mwpTour, {
          id: 'cwpSetShiftTimes',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.cwp_start_time_container',
          tetherOptions: {
            targetAttachment: 'top left',
            attachment: 'top right'
          },
          text: 'Set the desired start and end times of shift here. Move the start time to 11am and watch as the employee list below is recalculating based on your change.',
          scrollTo: true
        });

        mwpTour.addStep(cwpSetShiftTimes);


        var cwpRecommendedList = new Shepherd.Step(mwpTour, {
          id: 'cwpRecommendedList',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.cwp_bottom_right_container left',
          tetherOptions: {
            targetAttachment: 'top right',
            attachment: 'top left'
          },
          text: 'A ranked list of your employees with this position, highest recommendation on top. Click on an employee\'s name to see more information about the reason for their ranking on the left.',
          scrollTo: true
        });

        mwpTour.addStep(cwpRecommendedList);



        var cwpRecommendedBarStep = new Shepherd.Step(mwpTour, {
          id: 'cwpRecommendedBar',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.smart_sched_recommend_bar_wrapper left',
          tetherOptions: {
            targetAttachment: 'top left',
            attachment: 'top right'
          },
          text: 'Easy to read information about an employee in the context of the shift you\'re creating.',
          scrollTo: true
        });

        mwpTour.addStep(cwpRecommendedBarStep);


        var cwpPlusButtonStep = new Shepherd.Step(mwpTour, {
          id: 'cwpPlusButton',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.base_smart_cwp_emp_list_item left',
          tetherOptions: {
            targetAttachment: 'top left',
            attachment: 'top right'
          },
          buttons: [],
          text: 'Click \'Assign\' to assign an employee to this shift.'
        });

        var cwpPlusButtonStepDereg;
        cwpPlusButtonStep.on('show', function() {
          cwpPlusButtonStepDereg = $rootScope.$on(prefixEventName('cwpEmployeeListItemScheduled'), function() {
            mwpTour.next();
            cwpPlusButtonStepDereg();
          });
        });

        mwpTour.addStep(cwpPlusButtonStep);


        var cwpCreateStep = new Shepherd.Step(mwpTour, {
          id: 'cwpCreate',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.cwp_final_action_button left',
          text: 'Create this shift by clicking on the \'Create\' button.',
          buttons: []
        });

        var cwpCreateStepDereg;
        cwpCreateStep.on('show', function() {
            cwpCreateStepDereg = $rootScope.$on(prefixEventName('createWorkPeriodClosed'), function() {
            mwpTour.next();
            cwpCreateStepDereg();
          });
        });

        mwpTour.addStep(cwpCreateStep);


        var mwpShiftDropdownArrowStep = new Shepherd.Step(mwpTour, {
          id: 'mwpShiftDropdownArrow',
          classes: 'shepherd-theme-arrows',
          attachTo: '.intelli_view_shift_dropdown_area right',
          text: 'Use the dropdown arrow to open an employee\'s profile, edit, publish, split, duplicate, or delete the shift.',
          tetherOptions: {
            offset: '0px -10px'
          }
        });

        mwpTour.addStep(mwpShiftDropdownArrowStep);


        var reviewWeekStep = new Shepherd.Step(mwpTour, {
          id: 'reviewWeek',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_review_button_container top',
          text: 'Click on the \'Review Week\' button to have Shift Agent review your week schedule for various availability, day off, and other conflicts.',
          tetherOptions: {
            offset: '10px 0'
          }
        });

        mwpTour.addStep(reviewWeekStep);


        var publishButtonStep = new Shepherd.Step(mwpTour, {
          id: 'publishButton',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_publish_button_container top',
          text: 'Click on the \'Publish Now\' button to publish a day or a week at a time.',
          tetherOptions: {
            offset: '10px 0px'
          }
        });

        mwpTour.addStep(publishButtonStep);


        var weekViewButtonStep = new Shepherd.Step(mwpTour, {
          id: 'weekViewButton',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_week_view_link_button_container top',
          text: 'Click on the \'Week View\' button to look at all a full week of schedule by employee. This view is really great for printing the schedule or displaying it on a TV.',
          tetherOptions: {
            offset: '10px 0px'
          }
        });

        mwpTour.addStep(weekViewButtonStep);


        var deploymentButtonStep = new Shepherd.Step(mwpTour, {
          id: 'deploymentButton',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_deployment_link_button_container top',
          text: 'Click on the \'Daily Deployment\' button to open a printable listing of everyone working on a single day, great for posting on the wall every morning.',
          tetherOptions: {
            offset: '10px 0px'
          }
        });

        mwpTour.addStep(deploymentButtonStep);

        var infoIconStep = new Shepherd.Step(mwpTour, {
          id: 'infoIcon',
          classes: 'shepherd-theme-arrows',
          attachTo: '.standard_info_icon_area left',
          tetherOptions: {
            attachment: 'top right',
            targetAttachment: 'top left'
          },
          text: 'More help is always available by clicking on the <strong>i</strong>. Also check out <a href="https://support.shiftagent.com">https://support.shiftagent.com</a> for any questions you may have.',
          buttons: [
            {
              text: 'Finish',
              action: mwpTour.next

            }
          ]
        });

        mwpTour.addStep(infoIconStep);
      }());






      (function initMwpFasterTour() {
        mwpFasterTour = new Shepherd.Tour({
          defaults: stepDefaults
        });

        var emptyDayStep = new Shepherd.Step(mwpFasterTour, {
          id: 'emptyDay',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_budget_days bottom',
          text: 'Before we start the tour, navigate to a day without shifts by clicking on a date in the top bar.',
          tetherOptions: {
            offset: '-10px 0px'
          }
        });

        mwpFasterTour.addStep(emptyDayStep);


        var addShiftsIntroStep = new Shepherd.Step(mwpFasterTour, {
          id: 'addShiftsIntro',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_add_shifts_button bottom',
          text: 'Click on the \'Add Shifts\' button to quickly add multiple shifts to the day to multiple positions.',
          tetherOptions: {
            offset: '-10px 0px'
          },
          buttons: []
        });

        var addShiftsIntroStepDereg;
        addShiftsIntroStep.on('show', function() {
          addShiftsIntroStepDereg = $rootScope.$on(prefixEventName('quickAddOpened'), function() {
            mwpFasterTour.next();
            addShiftsIntroStepDereg();
          });
        });

        mwpFasterTour.addStep(addShiftsIntroStep);

        var positionDropdownStep = new Shepherd.Step(mwpFasterTour, {
          id: 'positionDropdown',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.quick_add_position_select left',
          text: 'Use the dropdown to select the position you want to create shifts for.',
          tetherOptions: {
            offset: '-10px 0px'
          }
        });

        mwpFasterTour.addStep(positionDropdownStep);


        var quickAddTimesStep = new Shepherd.Step(mwpFasterTour, {
          id: 'quickAddTimes',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.quick_add_shift_input_container right',
          text: 'Enter times for shifts here. Type <strong>6-4, 12:30p-6, 4p-2</strong> and watch as Shift Agent shows you the shifts you\'re generating directly below.',
          tetherOptions: {
            offset: '0px 0px'
          }
        });

        mwpFasterTour.addStep(quickAddTimesStep);

        var quickAddRemoveStep = new Shepherd.Step(mwpFasterTour, {
          id: 'quickAddRemove',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.quick_add_shift left',
          text: 'You can use the <strong>X</strong> in the corner of each shift to remove it.',
          tetherOptions: {
            offset: '0px 0px'
          }
        });

        mwpFasterTour.addStep(quickAddRemoveStep);


        var quickAddAnotherRowStep = new Shepherd.Step(mwpFasterTour, {
          id: 'quickAddAnotherRow',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.add_another_row_button_container left',
          text: 'Click here to add another position. Add another shift while you\'re at it!',
          tetherOptions: {
            offset: '0px 0px'
          }
        });

        quickAddAnotherRowStep.on('show', function() {
          var quickAddAnotherRowStepDereg = $rootScope.$on(prefixEventName('quickAddPositionRow'), function() {
            mwpFasterTour.next();
            quickAddAnotherRowStepDereg();
          });
        });

        mwpFasterTour.addStep(quickAddAnotherRowStep);


        var quickAddSubmitStep = new Shepherd.Step(mwpFasterTour, {
          id: 'quickAddSubmit',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.publish_button left',
          text: 'Click the button to create your shifts!',
          buttons: [],
          tetherOptions: {
            offset: '0px 0px'
          }
        });

        quickAddSubmitStep.on('show', function() {
          var quickAddSubmitStepDereg = $rootScope.$on(prefixEventName('quickAddClosed'), function() {
            mwpFasterTour.next();
            quickAddSubmitStepDereg();
          });
        });

        mwpFasterTour.addStep(quickAddSubmitStep);

        mwpFasterTour.addStep({
          id: 'unassignedShift',
          classes: 'shepherd-theme-arrows',
          tetherOptions: {
            offset: '-5px 0px'
          },
          text: 'This is an unassigned shift. It currently does not have an employee assigned to it. Let\'s fix that!',
          attachTo: '.intelli_view_shift.unassigned bottom'
        });

        var smartSchedulingOpenStep = new Shepherd.Step(mwpFasterTour, {
          id: 'smartSchedulingOpen',
          classes: 'shepherd-theme-arrows',
          tetherOptions: {
            offset: '-8px 0px'
          },
          text: 'Click on \'Smart Scheduling\' to fill these unassigned shifts with employees.',
          attachTo: '.smart_sched_menu_button bottom',
          buttons: []
        });

        smartSchedulingOpenStep.on('show', function() {
          var smartSchedulingOpenStepDereg = $rootScope.$on(prefixEventName('smartSchedulingOpened'), function() {
            mwpFasterTour.next();
            smartSchedulingOpenStepDereg();
          });
        });

        mwpFasterTour.addStep(smartSchedulingOpenStep);

        var miniDayViewStep = new Shepherd.Step(mwpFasterTour, {
          id: 'miniDayView',
          classes: 'shepherd-theme-arrows top_of_modal',
          tetherOptions: {
            offset: '-8px 0px'
          },
          text: 'The flashing gray shift is the selected shift that is being processed on the right hand side. You can click on any shift you like and fill that one.',
          attachTo: '.sa_mini_day_view_shift.selected bottom'
        });

        mwpFasterTour.addStep(miniDayViewStep);


        var recommendationAreaStep = new Shepherd.Step(mwpFasterTour, {
          id: 'recommendationArea',
          classes: 'shepherd-theme-arrows top_of_modal',
          tetherOptions: {
            offset: '-8px 0px'
          },
          text: 'The upper half on the right side by default shows you Shift Agent\'s recommendation for this shift.',
          attachTo: '.smart_sched_modal_wizard_employee_card_holder left'
        });

        mwpFasterTour.addStep(recommendationAreaStep);


        var assignRecommendedStep = new Shepherd.Step(mwpFasterTour, {
          id: 'assignRecommended',
          classes: 'shepherd-theme-arrows top_of_modal',
          tetherOptions: {
            offset: '-8px 0px'
          },
          text: 'Click \'Assign\' to give the selected shift to this employee.',
          attachTo: '.smart_sched_assign_button_area bottom',
          buttons: []
        });

        assignRecommendedStep.on('show', function() {
          var assignRecommendedStepDereg = $rootScope.$on(prefixEventName('userRecommendAssign'), function() {
            mwpFasterTour.next();
            assignRecommendedStepDereg();
          });
        });

        mwpFasterTour.addStep(assignRecommendedStep);

        var selectedShiftAdvancedStep = new Shepherd.Step(mwpFasterTour, {
          id: 'selectedShiftAdvanced',
          classes: 'shepherd-theme-arrows top_of_modal',
          tetherOptions: {
            offset: '-8px 0px'
          },
          attachTo: '.sa_mini_day_view_shift.selected bottom',
          text: 'When you assigned the previous shift, Shift Agent automatically advanced to the next shift.',
          buttons: [
            {
              text: 'Cool!',
              action: mwpFasterTour.next
            }
          ]
        });

        mwpFasterTour.addStep(selectedShiftAdvancedStep);


        var recommendTopBarStep = new Shepherd.Step(mwpFasterTour, {
          id: 'recommendTopBar',
          classes: 'shepherd-theme-arrows top_of_modal',
          tetherOptions: {
            offset: '-8px 0px'
          },
          attachTo: '.smart_sched_name_area bottom',
          text: 'Below the employee\'s name is their current number of hours this week, their target hours (manager desired hours), and their number of hours for the week with this shift.'
        });

        mwpFasterTour.addStep(recommendTopBarStep);

        var smartSchedWeekCalStep = new Shepherd.Step(mwpFasterTour, {
          id: 'smartSchedWeekCal',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.smart_sched_calendar_area bottom',
          text: 'This bar shows an employee\'s schedule for the week being scheduled. The blue shift is the currently selected shift. An orange shift is one that is overlapping with the current shift.'
        });

        mwpFasterTour.addStep(smartSchedWeekCalStep);


        var smartSchedRecListStep = new Shepherd.Step(mwpFasterTour, {
          id: 'smartSchedRecList',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.smart_sched_modal_wizard_names_scroller left',
          text: 'A list of all employee\'s with the selected shift\'s position, ordered by best fit. Click on a name to view more details above.'
        });

        mwpFasterTour.addStep(smartSchedRecListStep);


        var goToCalendarStep = new Shepherd.Step(mwpFasterTour, {
          id: 'goToCalendar',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.go_to_calendar_button_container left',
          text: 'After you assign a few more shifts, click \'Go to the Calendar\' to see your work on the timeline.',
          buttons: []
        });

        goToCalendarStep.on('show', function() {
          var goToCalendarStepDereg = $rootScope.$on(prefixEventName('smartSchedulingClosed'), function() {
            mwpFasterTour.next();
            goToCalendarStepDereg();
          });
        });

        mwpFasterTour.addStep(goToCalendarStep);


        var beginTemplatesStep = new Shepherd.Step(mwpFasterTour, {
          id: 'beginTemplates',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_budget_days bottom',
          text: 'Next, we\'ll explain how you can use templates to create a schedule. First, click on a day that doesn\'t have any shifts yet.'
        });

        mwpFasterTour.addStep(beginTemplatesStep);

        var manageTemplatesStep = new Shepherd.Step(mwpFasterTour, {
          id: 'manageTemplates',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_manage_templates_button_container top',
          tetherOptions: {
            attachment: 'bottom left',
            targetAttachment: 'top left',
            offset: '8px 8px'
          },
          text: 'Click on the \'Manage Templates\' button.',
          buttons: []
        });

        manageTemplatesStep.on('show', function() {
          var manageTemplatesStepDereg = $rootScope.$on(prefixEventName('manageTemplatesOpened'), function() {
            mwpFasterTour.next();
            manageTemplatesStepDereg();
          });
        });

        mwpFasterTour.addStep(manageTemplatesStep);


        var templatePreviewClickStep = new Shepherd.Step(mwpFasterTour, {
          id: 'templatePreviewClick',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.template_item bottom',
          text: 'You\'re looking at a list of all of your templates. Go ahead and click on the name of the first template.',
          buttons: []
        });

        templatePreviewClickStep.on('show', function() {
          var templatePreviewClickStepDereg = $rootScope.$on(prefixEventName('manageTemplatesSelectTemplate'), function() {
            mwpFasterTour.next();
            templatePreviewClickStepDereg();
          });
        });

        mwpFasterTour.addStep(templatePreviewClickStep);

        var templatePreviewStep = new Shepherd.Step(mwpFasterTour, {
          id: 'templatePreview',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.manage_templates_preview_container left',
          text: 'The right half of the screen now shows you the contents of the template, the departments and positions contained, and the number of labor hours therein.'
        });

        mwpFasterTour.addStep(templatePreviewStep);

        var templateActionsStep = new Shepherd.Step(mwpFasterTour, {
          id: 'templateActions',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.template_archive_container bottom',
          text: 'You can edit and clone the template using the buttons at left. The two icons are used for archiving and deleting the template.'
        });

        mwpFasterTour.addStep(templateActionsStep);

        var templateApplyStep = new Shepherd.Step(mwpFasterTour, {
          id: 'templateApply',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.template_item bottom',
          tetherOptions: {
            attachment: 'top left',
            targetAttachment: 'bottom left',
            offset: '-8px 0'
          },
          text: 'Now let\'s apply the template to today by clicking on the \'Apply\' button.',
          buttons: []
        });

        templateApplyStep.on('show', function() {
          var templateApplyStepDereg = $rootScope.$on(prefixEventName('manageTemplatesApplyTemplate'), function() {
            mwpFasterTour.next();
            templateApplyStepDereg();
          });
        });

        mwpFasterTour.addStep(templateApplyStep);


        var unassignedShiftEditInfoStep = new Shepherd.Step(mwpFasterTour, {
          id: 'unassignedShiftEditInfo',
          classes: 'shepherd-theme-arrows',
          attachTo: '.intelli_view_shift.shift.unassigned bottom',
          tetherOptions: {
            offset: '-12px 0px'
          },
          text: 'Once the template is applied you can easily make changes to the template by clicking on \'Edit\' and dragging the ends of the shift.'
        });

        mwpFasterTour.addStep(unassignedShiftEditInfoStep);

        var mwpWeekBudgetAreaStep = new Shepherd.Step(mwpFasterTour, {
          id: 'mwpWeekBudgetArea',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_week_budget_area bottom',
          tetherOptions: {
            offset: '-8px 25px'
          },
          text: 'Edit and drag one of the shifts in the template. As you make changes to the shifts you can see the total hours on this day update here. If you have a projection set, you\'ll also notice the color of the text change with the number.'
        });

        mwpFasterTour.addStep(mwpWeekBudgetAreaStep);

        var unapplyTemplateStep = new Shepherd.Step(mwpFasterTour, {
          id: 'unapplyTemplate',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_template_dropdown_clear bottom',
          text: 'You can easily remove the template by clicking on the \'X\'.'
        });

        mwpFasterTour.addStep(unapplyTemplateStep);


        var smartSchedulingOpenAgainStep = new Shepherd.Step(mwpFasterTour, {
          id: 'smartSchedulingOpenAgain',
          classes: 'shepherd-theme-arrows',
          tetherOptions: {
            offset: '-8px 0px'
          },
          text: 'Click on \'Smart Scheduling\' to fill the template.',
          attachTo: '.smart_sched_menu_button bottom',
          buttons: []
        });

        smartSchedulingOpenAgainStep.on('show', function() {
          var smartSchedulingOpenAgainStepDereg = $rootScope.$on(prefixEventName('smartSchedulingOpened'), function() {
            mwpFasterTour.next();
            smartSchedulingOpenAgainStepDereg();
          });
        });

        mwpFasterTour.addStep(smartSchedulingOpenAgainStep);

        var goToCalendarAgainStep = new Shepherd.Step(mwpFasterTour, {
          id: 'goToCalendarAgain',
          classes: 'shepherd-theme-arrows top_of_modal',
          attachTo: '.go_to_calendar_button_container left',
          text: 'After you\'re finished assigning employees, click \'Go to the Calendar\' to see your work on the timeline.',
          buttons: []
        });

        goToCalendarAgainStep.on('show', function() {
          var goToCalendarAgainStepDereg = $rootScope.$on(prefixEventName('smartSchedulingClosed'), function() {
            mwpFasterTour.next();
            goToCalendarAgainStepDereg();
          });
        });

        mwpFasterTour.addStep(goToCalendarAgainStep);


        var otherTemplateApplyStep = new Shepherd.Step(mwpFasterTour, {
          id: 'otherTemplateApply',
          classes: 'shepherd-theme-arrows',
          attachTo: '.mwp_template_dropdown bottom',
          tetherOptions: {
            offset: '-8px 0px'
          },
          text: 'When you close Smart Scheduling your template will be automatically unapplied. You can click on \'Choose a Template\' to select the template again.'
        });

        mwpFasterTour.addStep(otherTemplateApplyStep);


        var infoIconAgainStep = new Shepherd.Step(mwpFasterTour, {
          id: 'infoIconAgain',
          classes: 'shepherd-theme-arrows',
          attachTo: '.standard_info_icon_area left',
          tetherOptions: {
            attachment: 'top right',
            targetAttachment: 'top left'
          },
          text: 'More help is always available by clicking on the <strong>i</strong>. Also check out <a href="https://support.shiftagent.com">https://support.shiftagent.com</a> for any questions you may have.',
          buttons: [
            {
              text: 'Finish',
              action: mwpFasterTour.next

            }
          ]
        });

        mwpFasterTour.addStep(infoIconAgainStep);
      }());


      this.startOrgProfileTour = function() {
        if (this.aTourIsActive()) {
          this.cancelActiveTour();
        }
        return orgProfileTour.start();
      };

      this.startMwpTour = function() {
        if (this.aTourIsActive()) {
          this.cancelActiveTour();
        }
        return mwpTour.start();

        //return mwpTour.show('mwpShiftDropdownArrow');
      };

      this.startMwpFasterTour = function() {
        //return mwpFasterTour.show('unassignedShiftEditInfo');
        if (this.aTourIsActive()) {
          this.cancelActiveTour();
        }

        return mwpFasterTour.start();
      };

      this.aTourIsActive = function() {
        return !_.isNull(Shepherd.activeTour) && !_.isUndefined(Shepherd.activeTour);
      };

      this.cancelActiveTour = function() {
        if (this.aTourIsActive()) {
          Shepherd.activeTour.cancel();
        }
      };

    }]);
